import React, { useState, useEffect } from "react";
import { Carousel, Row, Col, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useScreenSize, useCustomScreen } from "../Utils";

const CarouselItems = [
  {
    id: 1,
    personImage: "/images/Roofers.png",
    personName: "Black Diamond Roofing Company <br /><b>Maryland</b>",
    content:
      "“Excellent company with excellent customer service. Great team to work with, and the pricing blows away the competition.”",
  },
  {
    id: 2,
    personImage: "/images/InsuranceAdjusters.png",
    personName: "Texola <br /><b>Texas</b>",
    content:
      "“I've been using rooftop since 2012 and they've never let us down. Great customer service, competitive pricing and always accurate. Use it!”",
  },
  {
    id: 3,
    personImage: "/images/Contractors.png",
    personName: "JS Held <br /><b>Texas</b>",
    content:
      "“Rooftop Measurements are my go-to for roof data reports. I always appreciate their accuracy and quick turnaround, highly recommend their company.”",
  },
  {
    id: 4,
    personImage: "/images/Contractors.png",
    personName: "Red's Construction of Whidbey Island <br /><b>Washington</b>",
    content:
      "“Blaine and his team produce topnotch roof reports promptly every time. The report helps us contractors get our customers the bids they desire without the trouble of getting on the roof. I've used Rooftop Measurements for many years and these reports are worth every penny.”",
  },
];

export default function CarouselSection() {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  const token = localStorage.getItem("token");

  return (
    <div style={{ height: "auto", marginBottom: "4rem" }}>
      <div
        style={{
          backgroundColor: "#BAE5EC",
          height: isSmallScreen ? "" : "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container fluid className="p-4">
          <Carousel
            className="p-4"
            activeIndex={index}
            onSelect={handleSelect}
            variant="dark"
            controls={false}
            indicators
          >
            {CarouselItems.map((item) => {
              const { id, personImage, personName, content } = item;
              return (
                <Carousel.Item key={`${personName}-${id}`}>
                  <Row className="align-items-center text-center p-3">
                    <Col xs={12} md={4}>
                      <img
                        src={personImage}
                        alt="person"
                        className="rounded-circle mb-3"
                        style={{
                          width: is4kScreen
                            ? "12rem"
                            : isXxlScreen
                            ? "6rem"
                            : isXlScreen
                            ? "6rem"
                            : isIpadProPortrait
                            ? "8rem"
                            : isLargeScreen
                            ? "5rem"
                            : "5rem",
                          backgroundColor: "#fff",
                        }}
                      />
                      <h5
                        style={{
                          color: "#404040",
                          fontSize: is4kScreen
                            ? "3rem"
                            : isXxlScreen
                            ? "1.7rem"
                            : isXlScreen
                            ? "1.6rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1.5rem"
                            : isMediumScreen
                            ? "1.7rem"
                            : isSmallScreen
                            ? "1.3rem"
                            : "40px",
                        }}
                        dangerouslySetInnerHTML={{ __html: personName }}
                      />
                    </Col>
                    <Col xs={12} md={8}>
                      <h3
                        style={{
                          color: "#404040",
                          fontSize: is4kScreen
                            ? "3.5rem"
                            : isXxlScreen
                            ? "1.9rem"
                            : isXlScreen
                            ? "1.7rem"
                            : isIpadProPortrait
                            ? "2rem"
                            : isLargeScreen
                            ? "1.5rem"
                            : isMediumScreen
                            ? "1.7rem"
                            : isSmallScreen
                            ? "1.3rem"
                            : "40px",
                        }}
                      >
                        {content}
                      </h3>
                    </Col>
                  </Row>
                </Carousel.Item>
              );
            })}
          </Carousel>
        </Container>
      </div>
{!token && (
      <div
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container fluid>
          <Row>
            <div className="col-xl-12 col-lg-12 text-center mb-5">
              <h1
                style={{
                  fontSize: is4kScreen
                    ? "4rem"
                    : isXxlScreen
                    ? ""
                    : isXlScreen
                    ? " "
                    : isIpadProPortrait
                    ? "3rem"
                    : isLargeScreen
                    ? "2rem"
                    : isSmallScreen
                    ? "2rem"
                    : "40px",
                  color: "#000",
                }}
                className="my-5"
              >
                <strong>Sign up</strong> and get your first report{" "}
                <b style={{ color: "#57C0D1" }}>FREE</b>
              </h1>
              <button
                className="lets-go-btn"
                onClick={() => navigate("/signup")}
                style={{
                  fontSize: is4kScreen
                    ? "4rem"
                    : isLargeScreen
                    ? "2rem"
                    : isSmallScreen
                    ? "1.5rem"
                    : "",
                }}
              >
                Let's go
              </button>
            </div>
          </Row>
        </Container>
      </div>
)}
    </div>
             
  );
  
}
